import { render, staticRenderFns } from "./sub-request-selector.vue?vue&type=template&id=1487b380&"
import script from "./sub-request-selector.vue?vue&type=script&lang=js&"
export * from "./sub-request-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports